import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getClinicById = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId)
}

const updateClinic = (clinicId,data) =>{
    return axios.put(API_URL+"clinics/"+clinicId,data)
}

const getHours = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/hours")
}

const updateHours = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/hours",data)
}
const getRecallHours = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/recall-timings")
}
const getRecallSettings = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/settings")
}
const updateRecallHours = (clinicId,data) =>{
    return axios.put(API_URL+"clinics/"+clinicId+"/recalls/recall-timings",data)
}
const getSocialLinks = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/social-links")
}
const addUpdateSocialLinks = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/social-links",data)
}
const deleteSocialLink = (clinicId,socialLinkId) =>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/social-links/"+socialLinkId)
}

const getCLBrands = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/cl-brands")
}
const addUpdateCLBrands = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/cl-brands",data)
}
const deleteCLBrands = (clinicId,brandId) =>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/cl-brands/"+brandId)
}

const getReputationCode = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reputation-enhancements")
}
const getReputationLinks = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reputation-enhancements/links")
}
const addUpdateReputationLinks = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/reputation-enhancements",data)
}
const deleteReputationLink = (clinicId,LinkId) =>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/reputation-enhancements/"+LinkId)
}

const getUsers = (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users")
}
const getUsersByRole = (clinicId,role="staff") =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users?role="+role)
}
const updateUser = (clinicId, userId, data) =>{
    return axios.put(API_URL+"clinics/"+clinicId+"/users/"+userId, data)
}
const getUserById = (clinicId,userId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users/"+userId)
}
const getUserLog = (clinicId,userId, pageNo=0, pageSize=50)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"users/logs/?userId="+userId+"&pageNo="+pageNo+"&pageSize="+pageSize)
}
const changeUserPassword = (clinicId,userId,data)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/users/"+userId+"/change-password",data)
}

const getClinicFeatures = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/features")
}
const getReminderSettings = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/reminder-settings")
}
const updateReminderSettings = (clinicId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/reminder-settings",data)
}

const settingsService = {
    getClinicById,
    updateClinic,
    getHours,
    updateHours,
    getRecallHours,
    updateRecallHours,
    getRecallSettings,
    getSocialLinks,
    addUpdateSocialLinks,
    deleteSocialLink,
    getCLBrands,
    addUpdateCLBrands,
    deleteCLBrands,
    getReputationCode,
    getReputationLinks,
    addUpdateReputationLinks,
    deleteReputationLink,
    getUsers,
    getUsersByRole,
    updateUser,
    getUserById,
    getUserLog,
    changeUserPassword,
    getClinicFeatures,
    getReminderSettings,
    updateReminderSettings
}

export default settingsService